module.exports = __webpack_public_path__ + "static/media/twitter_button.7007fb39.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/img/twitter_button.png
// module id = 395
// module chunks = 2